<template>
  <v-dialog v-model="visible" scrollable :persistent="ventanaPersistente" :max-width="anchoMaximo" @click:outside="clickFuera">
    <v-card elevation="4" :min-height="altoMinimo">
      <v-card-title :class="claseTitulo">
        <v-icon v-if="icono" class="ml-n2 mr-4 pa-2" style="background: rgba(10,30,30,.1); box-shadow: 2px 2px 5px; border-radius: 5px;">{{icono}}</v-icon>
        {{titulo}}<span class="ml-2" style="font-weight: 300" v-if="campoSujetoAccion && datosRegistro [campoSujetoAccion]">- {{datosRegistro [campoSujetoAccion]}}</span>
      </v-card-title>
      <v-card-text :class="classVCardText">

        <!-- <pre>{{definicionCampos}}</pre> -->
        <!-- <pre>{{datosRegistro}}</pre> -->
        <v-form :key="claveFormulario" v-if="definicionCampos" v-on:submit.prevent v-model="camposValidados" ref="__vform__" :readonly="esAccionEliminar">
          <slot :definicionCampos="definicionCampos" :datosRegistro="datosRegistro" :accionCrud="accionCRUD" :esAccionEliminar="esAccionEliminar">
            <span v-for="(dc, nombreCampo) in definicionCampos" :key="nombreCampo">
              <template v-if="procedeVisualizarCampo(dc)">
                <CampoFormularioDatos
                  :nombre-campo="nombreCampo"
                  :definicion-campos="definicionCampos"
                  :datos-registro="datosRegistro"
                  :readonly="esAccionEliminar"
                  :disabled="dc.solo_lectura ? dc.solo_lectura.includes (accionCRUD) : false"
                  @montado="campoFormularioDatosMontado"
                />
              </template>
            </span>
          </slot>
        </v-form>
      </v-card-text>
      <v-card-actions class="mt-n1">
        <v-spacer />
        <template v-if="!env.VUE_APP_FORMULARIOS_SOLO_LECTURA">
          <v-btn v-if="accionCRUD == 'C'" text color="green darken-2" @click="guardar" :disabled="!permitirGuardar">{{ $t (textoBotonAnadir) }}</v-btn>
          <v-btn v-else-if="accionCRUD == 'U'" text color="green darken-2" @click="guardar" :disabled="!permitirGuardar">{{ $t (textoBotonEditar) }}</v-btn>
          <v-btn v-else text color="red darken-2" @click="eliminar">{{ $t (textoBotonEliminar) }}</v-btn>
        </template>
        <v-btn text color="black lighten-2" @click="cancelar">{{ $t (textoBotonCancelar) }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import CONSTANTES_CRUD from "@/constantesCRUD"
// import api from "@/api"
import CampoFormularioDatos from '@/components/CampoFormularioDatos.vue'

export default {
  components: {
    CampoFormularioDatos
  },
  props: {
    icono: {
      type: String,
      default: ""
    },
    anchoMaximo: {
      type: String,
      default: "550"
    },
    altoMinimo: {
      type: String,
      default: "0"
    },
    sinMargenes: {
      type: Boolean,
      default: false,
    },
    textoBotonAnadir: {
      type: String,
      default: "Guardar"
    },
    textoBotonEditar: {
      type: String,
      default: "Guardar"
    },
    textoBotonEliminar: {
      type: String,
      default: "Eliminar"
    },
    textoBotonCancelar: {
      type: String,
      default: "Cancelar"
    }
  },
  data () {
    this.copiaDatosRegistro = null;
    this.funcionAccion = null;
    this.funcionCancelar = null;
    this.eventos = null;
    return {
      claveFormulario: null, // cada vez que cambia esta clave, se reconstruye el formulario (:key en v-form)
      visible: false,
      camposValidados: false,
      claseTitulo: "",

      accionCRUD: "",
      titulo: "",
      definicionCampos: null,
      datosRegistro: {},
      campoSujetoAccion: ""
    }
  },
  computed: {
    env () {
      return process.env;
    },
    classVCardText() {
      let clases='';
      if (this.sinMargenes)
        clases = clases + " pa-0";
      else
        clases = clases + " pt-8";
      return clases;
    },
    permitirGuardar() {
      return this.camposValidados && this.elRegistroHaSidoModificado();
    },
    esAccionEliminar() {
      return this.accionCRUD == CONSTANTES_CRUD.ACCION.DELETE;
    },
    ventanaPersistente() {
      return !this.permitirEscaparDeLaVentana();
    },
  },
  methods: {
    vaciarDatosRegistro () {
      for (const clave in this.datosRegistro)
        this.$delete (this.datosRegistro, clave);
    },
    campoFormularioDatosMontado (campoFormularioDatos) {
      this.$emit ('campo-formulario-datos-montado', campoFormularioDatos);
    },
    procedeVisualizarCampo (dc) {
      let campoVisible = true;
      if (dc && dc.visibilidad) {
        campoVisible &= dc.visibilidad.toUpperCase().includes(this.accionCRUD);
      }
      if (dc && dc.condicion_visibilidad_en_formulario) {
        let funcionAux = function () { return eval (dc.condicion_visibilidad_en_formulario) };
        campoVisible &= funcionAux.call (this);
      }
      return campoVisible;
    },
    elRegistroHaSidoModificado() {
      return Object.keys (this.datosRegistro).some ( (nombreCampo) => {
        if (nombreCampo.includes ('__VT')) // omitimos campos que albergan los valores transformados
          return false;
        else
          return JSON.stringify (this.datosRegistro[nombreCampo]) != JSON.stringify (this.copiaDatosRegistro[nombreCampo]); // usamos "JSON.stringify" para poder comparar valores de tipo array
      });
    },
    arrayCambiosEnRegistro (){
      let registroAux = {};
      // console.log ('this.copiaDatosRegistro', JSON.stringify (this.copiaDatosRegistro));
      // console.log ('this.datosRegistro', JSON.stringify (this.datosRegistro));
      Object.entries (this.datosRegistro).forEach ( ([nombreCampo, valor]) => {
        //console.log (nombreCampo);
        if (nombreCampo.includes ('__VT') || nombreCampo.includes ('__AUX') || nombreCampo == '!!') // omitimos campos auxiliares
          return;
        let dc = this.definicionCampos [nombreCampo];
        //console.log ('dc', dc);

        let campoVisible = this.procedeVisualizarCampo (dc);
        if (dc && dc.condicion_visibilidad_en_formulario && !campoVisible) {
          valor = dc.valor_por_defecto;
          if (valor === undefined)
            valor = null;
        }

        if (JSON.stringify (valor) == JSON.stringify (this.copiaDatosRegistro[nombreCampo])) // usamos "JSON.stringify" para poder comparar valores de tipo array y nulos
          return; // omitimos los campos que no han sido modificados
        if (dc.extra && (dc.extra.toUpperCase() == "AUTO_INCREMENT"))
          return; // omitimos los campos "auto_increment"
        let copia_valor = JSON.parse (JSON.stringify (valor));
        if (dc.seleccion_multiple && Array.isArray (copia_valor)) {
          copia_valor.sort ((a, b) => a - b);
        }
        registroAux [nombreCampo] = copia_valor;
      });
      // console.log ('registroAux', JSON.stringify (registroAux));
      return registroAux;
    },
    ocultar(cancelarClicado) {
      // lanzamos el evento "antesCerrarFormulario"
      if (this.eventos.antesCerrarFormulario)
        if (!this.eventos.antesCerrarFormulario (this, cancelarClicado))
          return;

      this.visible = false;
    },
    async guardar() {
      if (this.funcionAccion != null) {
        let arrayCambiosEnRegistro = this.arrayCambiosEnRegistro();

        // lanzamos el evento "Antes de Guardar"
        if (this.eventos.antesGuardar)
          if (!await this.eventos.antesGuardar (this, arrayCambiosEnRegistro))
            return;

        if (await this.funcionAccion (this, this.datosRegistro, this.copiaDatosRegistro, arrayCambiosEnRegistro)) {
          // lanzamos el evento "Despues de Guardar"
          if (this.eventos.despuesGuardar)
            this.eventos.despuesGuardar (this, arrayCambiosEnRegistro);

          this.ocultar();
        }
      }
    },
    async eliminar() {
      if (this.funcionAccion != null) {
        if (await this.funcionAccion (this, this.datosRegistro, this.copiaDatosRegistro))
          this.ocultar();
      }
    },
    async cancelar() {
      if (this.funcionCancelar != null) {
        if (await this.funcionCancelar (this))
          this.ocultar(true);
      } else
        this.ocultar(true);
    },
    permitirEscaparDeLaVentana() {
      return (this.accionCRUD != CONSTANTES_CRUD.ACCION.CREATE && !this.permitirGuardar);
    },
    clickFuera (){
      if (this.permitirEscaparDeLaVentana())
        this.cancelar();
    },
    reiniciarEstadoValidacionCampos() {
      if (this.$refs['__vform__'])
        this.$refs['__vform__'].resetValidation();
    },
    forzarValidacionCampos() {
      if (this.$refs['__vform__'])
        this.$refs['__vform__'].validate();
    },
    mostrar (accionCRUD, titulo, definicionCampos, registro, campoSujetoAccion, eventos) {
      this.claveFormulario = new Date().getTime();
      this.accionCRUD = accionCRUD;
      this.titulo = titulo;
      this.definicionCampos = definicionCampos;
      this.datosRegistro = registro;
      this.copiaDatosRegistro = JSON.parse (JSON.stringify (registro)); // importante: hacemos una copia de "registro" para poder hacer UPDATES y además, saber qué ha cambiado
      this.campoSujetoAccion = campoSujetoAccion;
      this.funcionAccion = eventos.botonAccion; // debe ser una funcion "async", para poder abortar la accion si así se necesitara (devolviendo "false")
      this.funcionCancelar = eventos.botonCancelar;
      this.eventos = eventos;

      // establecemos el titulo del formulario segun la accion
      if (this.accionCRUD == CONSTANTES_CRUD.ACCION.UPDATE)
        this.claseTitulo = "tituloModificar"
      else if (this.accionCRUD == CONSTANTES_CRUD.ACCION.DELETE)
        this.claseTitulo = "tituloEliminar"
      else
        this.claseTitulo = "tituloNuevo";

      // si se trata de accion CREATE, hacemos 2 cositas:
      if (this.accionCRUD == CONSTANTES_CRUD.ACCION.CREATE) {
        for (const nombreCampo in this.definicionCampos) {
          const dc = this.definicionCampos[nombreCampo];
          // asignamos valores por defecto a campos con NULL
          if ((this.datosRegistro[nombreCampo] == null) && ('valor_por_defecto' in dc))
            this.$set (this.datosRegistro, nombreCampo, dc.valor_por_defecto);
          // establecemos como valor por defecto los valores que serán forzados en el INSERT
          if ('forzar_valor_insert' in dc)
            if (dc.forzar_valor_insert)
              this.$set (this.datosRegistro, nombreCampo, JSON.parse (dc.forzar_valor_insert));
        }
      }

      // lanzamos el evento "Antes de Abrir"
      if (this.eventos.antesAbrir)
        this.eventos.antesAbrir (this);

      // necesario: Reiniciar el estado de validacion del formulario cada vez que abrimos (si no lo hacemos, puede saltar las
      // validación en campos que todavía no han sido "tocados")
      this.reiniciarEstadoValidacionCampos();

      // si la accion es Añadir, ponemos el foco automaticamente en el primer campo
      if (this.accionCRUD == CONSTANTES_CRUD.ACCION.CREATE) {
        setTimeout (() => {
          for (var nombreCampo in this.definicionCampos) {
            if (this.procedeVisualizarCampo (this.definicionCampos [nombreCampo]))
              if (this.$refs[nombreCampo] != undefined) {
                this.$refs[nombreCampo][0].focus();
                break;
              }
          }
        }, 250);
      }

      // finalmente, mostramos el dialogo:
      this.visible = true;
    },
  },
  mounted() {
    this.$emit ('montado', this);
  }
};
</script>

<style>
.tituloNuevo {
  background-color: #C0F0C0;
}
.tituloModificar {
  background-color: #90D0F0;
}
.tituloEliminar {
  background-color: #FFA09C;
}
</style>